module.exports = "/assets/7e857c2645e47ae8a011f40ccf588976.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OG.png
// module id = 1679
// module chunks = 0